import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import DialogDraw from 'src/components/medicalSchema/TabRecords/DialogDraw';
import DialogTemplate from 'src/components/medicalSchema/TabRecords/DialogTemplate';
import SlideItem from './SlideItem';
import { useSearchParams } from 'react-router-dom';
import { useNotify } from 'src/context/ContextNotify';
import { getAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';
import KartesList from './KartesList';

export type TemplateType = {
  id: number;
  name: string;
  categoryid: number;
  thumbnail: string;
};

const History = () => {
  const notifyContext = useNotify();
  const [searchParams] = useSearchParams();
  const patientid = searchParams.get('id');
  const [searchBox, setSearchBox] = useState(false);
  const [openDialogTemplate, setOpenDialogTemplate] = useState(false);
  const [openDialogDraw, setOpenDialogDraw] = useState(false);
  const [rowSelected, setRowSelected] = useState(0);

  const [templateActive, setTemplateActive] = useState<TemplateType | null>(
    null
  );
  const [templateDetail, setTemplateDetail] = useState(null);
  const [patient, setPatient] = useState(null);
  const [templates, setTemplates] = useState<TemplateType[]>([]);
  const [schemaList, setSchemaList] = useState([]);
  // const [checkAPI, setCheckAPI] = useState(false);
  const [karteEdit, setKarteEdit] = useState({});
  const [isKarteEdit, setIsKarteEdit] = useState(false);
  const token = getToken();

  const getTemplates = () => {
    try {
      // setCheckAPI(false);
      getAPI(`/patient/view?patientid=${patientid}&token=${token}`)
        .then((res) => {
          if (res.code === 200) {
            setTemplates(res.data.shemas);
            setSchemaList(res.data.kartes);
            setPatient(res.data.patient);
          } else {
            setTemplates([]);
            setSchemaList([]);
            setPatient(null);
          }

          if (res.code === 403 || res.code === 500 || res.code === 501) {
            notifyContext.setNotifyMessage({
              show: true,
              message: res.msg,
              type: 'error',
            });
          }

          setTemplateActive(null);
        })
        .finally(() => {
          // setCheckAPI(true);
        });
    } catch (error) {
      console.error('Failed to fetch data:', error);
      return;
    }
  };

  useEffect(() => {
    getTemplates();
    // eslint-disable-next-line
  }, []);

  const handleSearchTemplate = (keysearch: string) => {
    getAPI(
      `/master/shema-search?keyword=${keysearch}&status=1&page=1&pageline=100&token=${token}`
    ).then((res) => {
      if (res.code === 200) {
        setTemplates(res.data.items);
      } else {
        setTemplates([]);
      }
      setTemplateActive(null);
    });
  };

  // const handleCreateTemplate = () => {
  //   setOpenDialogTemplate(true);
  // };

  const handleCloseDialogTemplate = () => {
    setOpenDialogTemplate(false);
  };

  const handleSelectedTemplate = () => {
    setIsKarteEdit(false);
    if (templateActive === null) {
      setTemplateDetail(null);
      setOpenDialogTemplate(false);
      setOpenDialogDraw(true);
      return;
    }
    getAPI(`master/shema-detail?id=${templateActive.id}&token=${token}`).then(
      (res) => {
        if (res.code === 200) {
          setTemplateDetail(res.data);
          setOpenDialogTemplate(false);
          setOpenDialogDraw(true);
        }
      }
    );
  };

  const handleCreateDraw = () => {
    setOpenDialogDraw(true);
  };

  const handleCloseDialogDraw = () => {
    setOpenDialogDraw(false);
  };

  const handleBtnReturn = () => {
    setOpenDialogTemplate(true);
    setOpenDialogDraw(false);
  };

  const handleTemplateClick = (template = null) => {
    setTemplateActive(template);
  };

  const handleDeleteKartes = () => {
    getAPI(
      `karte/get-patient-kartes?patientid=${patientid}&token=${token}`
    ).then((res) => {
      if (res.code === 200) {
        setSchemaList(res.data.kartes);
      }
    });
  };

  const handleEditCanvas = (karteid: number) => {
    getAPI(
      `karte/detail?id=${karteid}&patientid=${patientid}&token=${token}`
    ).then((res) => {
      if (res.code === 200) {
        setIsKarteEdit(true);
        setKarteEdit(res.data);
        setOpenDialogDraw(true);
      }
    });
  };

  const handleRowClick = (rowIndex: number) => {
    setRowSelected(rowIndex);
    setSearchBox(false);
  };

  const handleSearchBox = () => {
    setSearchBox(!searchBox);
  };

  return (
    <Stack width={'100%'} position={'relative'}>
      <Stack
        direction={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
        height={'48px'}
        bgcolor={'primary.light'}
        p={'12px 16px'}
        onClick={handleSearchBox}
        sx={{ cursor: 'pointer' }}
      >
        <Typography>カルテ検索</Typography>
        <Box
          component='img'
          src={`/images/icons/ic-arrow-${searchBox ? 'down' : 'up'}.svg`}
          alt='ic-arrow-up-list-schema'
          width={'24px'}
          height={'24px'}
        ></Box>
      </Stack>
      {schemaList.length > 0 && searchBox && (
        <KartesList
          schemaList={schemaList}
          // handleDeleteKartes={handleDeleteKartes}
          handleRowClick={handleRowClick}
        />
      )}
      {
        schemaList.length > 0 && (
          <SlideItem
            rowSelected={rowSelected}
            kartes={schemaList}
            handleDeleteKartes={handleDeleteKartes}
            handleEditCanvas={handleEditCanvas}
          />
        )
      }

      <DialogTemplate
        templates={templates}
        openDialogTemplate={openDialogTemplate}
        handleCloseDialogTemplate={handleCloseDialogTemplate}
        handleTemplateClick={handleTemplateClick}
        templateActive={templateActive}
        handleSelectedTemplate={handleSelectedTemplate}
        handleSearchTemplate={handleSearchTemplate}
      />
      <DialogDraw
        openDialogDraw={openDialogDraw}
        handleCreateDraw={handleCreateDraw}
        handleCloseDialogDraw={handleCloseDialogDraw}
        handleBtnReturn={handleBtnReturn}
        templateActive={templateActive}
        templateDetail={templateDetail}
        karteEdit={karteEdit}
        isKarteEdit={isKarteEdit}
        patient={patient}
      />
    </Stack>
  );
};

export default History;
